import { render, staticRenderFns } from "./MigrationBanner.vue?vue&type=template&id=593c40c2"
import script from "./MigrationBanner.vue?vue&type=script&lang=js"
export * from "./MigrationBanner.vue?vue&type=script&lang=js"
import style0 from "./MigrationBanner.vue?vue&type=style&index=0&id=593c40c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports